import { useEffect, useState } from 'react'

interface Countdown {
  hours: string
  minutes: string
  seconds: string
}

const pad = (n: number): string => String(Math.max(0, n)).padStart(2, '0')

export function useCountdown(durationHours: number): Countdown {
  const [remaining, setRemaining] = useState<number>(durationHours * 3600)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
